{
  "App": "ایپ",
  "Profile": "پروفائل",
  "My Account": "میرا اکاؤنٹ",
  "Contacts": "رابطے",
  "Preferences": "ترجیحات",
  "Family Language": "فیملی کی زبان",
  "Program Consent": "پروگرام کی رضامندی",
  "Yes": "ہاں",
  "No": "نہیں",
  "Not submitted": "جمع نہیں کرایا گیا",
  "See anything missing? Contact your Caring Adult": "دیکھیں کہ کوئی چیز رہ تو نہیں گئی؟ اپنی دیکھ بھال کرنے والے بالغ فرد سے رابطہ کریں",
  "Messages": "پیغامات",
  "Caring Adult for": "دیکھ بھال کرنے والا بالغ فرد برائے",
  "Former Caring Adult for": "دیکھ بھال کرنے والا سابقہ بالغ فرد برائے",
  "Write your message here...": "...اپنا پیغام یہاں لکھیں",
  "I need help with": "مجھے اس میں مدد کی ضرورت ہے",
  "Academic": "تعلیم و تدریس",
  "After School/ Out of School": "اسکول کے بعد/اسکول سے باہر",
  "Applying for benefits": "مراعات کے لیے درخواست دینا",
  "Childcare": "نگہداشت اطفال",
  "Employment / Adult Education": "ملازمت/تعلیم بالغاں",
  "Food": "کھانے پینے کی اشیاء",
  "Housing": "رہائش",
  "Legal services": "قانونی خدمات",
  "Material Resources / Clothing / Laundry": "مادی وسائل/کپڑے/لانڈری",
  "Mental/emotional health": "دماغی/جسمانی صحت",
  "Physical health/asthma": "جسمانی صحت/دمہ",
  "Transportation": "ٹرانسپورٹ",
  "Send": "بھیجیں",
  "Today": "آج",
  "No messages yet": "ابھی تک کوئی پیغامات نہیں",
  "No messages": "کوئی پیغامات نہیں",
  "Start a conversation below": "ذیل میں بات چیت شروع کریں",
  "This Caring Adult is no longer available": "دیکھ بھال کرنے والا یہ بالغ فرد مزید دستیاب نہیں ہے",
  "No longer available ": "مزید دستیاب نہیں ہے ",
  "Monday": "پیر",
  "Tuesday": "منگل",
  "Wednesday": "بدھ",
  "Thursday": "جمعرات",
  "Friday": "جمعہ",
  "Saturday": "ہفتہ",
  "Sunday": "اتوار",
  "Emergency Contacts": "ہنگامی رابطے",
  "Supervisor of Social Workers for the Bronx": "برونکس کے سوشل ورکرز کا/کی سپروائزر",
  "Student Services Manager, High School District": "اسٹوڈنٹ سروسز منیجر، ہائی اسکول ڈسٹرکٹ",
  "Social Worker, Central Crisis Support Team": "سوشل ورکر، سنٹرل کرائسز سپورٹ ٹیم (Central Crisis Support Team)",
  "Support Line": "اسپورٹ لائن",
  "Suicide and Crisis Lifeline": "خودکشی اور بحرانوں کی لائف لائن (Suicide and Crisis Lifeline)",
  "Emergencies": "ہنگامی حالات",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "اگر آپ کو کسی جان لیوا ایمرجنسی کا سامنا ہو اور آپ کو فوری مدد کی ضرورت ہو، تو 911 پر کال کریں یا ٹیکسٹ کریں",
  "About New Visions": "New Visions کے بارے میں",
  "Privacy and Terms": "رازداری اور شرائط",
  "Homepage": "ہوم پیج",
  "Home Page": "ہوم پیج",
  "My family": "میری فیملی",
  "Available Services": "دستیاب خدمات",
  "Grade": "گریڈ",
  "School": "اسکول",
  "Attendance this year": "اس سال کی حاضری",
  "Absences last 5 days": "پچھلے 5 دنوں کی غیرحاضریاں",
  "Caring Adult": "دیکھ بھال کرنے والا بالغ فرد",
  "Message": "پیغام",
  "Not available": "دستیاب نہیں",
  "Not yet assigned": "ابھی تک تفویض نہیں کیا گیا",
  "No absences": "کوئی غیرحاضریاں نہیں",
  "Phone not available": "فون دستیاب نہیں ہے",
  "Email address not available": "ای میل ایڈرس دستیاب نہیں ہے",
  "January": "جنوری",
  "February": "فروری",
  "March": "مارچ",
  "April": "اپریل",
  "May": "مئی",
  "June": "جون",
  "July": "جولائی",
  "August": "اگست",
  "September": "ستمبر",
  "October": "اکتوبر",
  "November": "نومبر",
  "December": "دسمبر",
  "Sidenav": "سائیڈ نیویگیشن",
  "Home": "ہوم",
  "Log out": "لاگ آوٹ",
  "Accessibility": "رسائی",
  "Skip to main content": "مرکزی مواد پر جائیں",
  "Email": "ای میل",
  "Phone": "فون",
  "Family Portal": "فیملی پورٹل",
  "Every Child and Family is Known": "ہر بچے اور خاندان کو جانا جاتا ہے",
  "Family Portal: Every Child and Family is Known": "فیملی پورٹل: ہر بچے اور خاندان کو جانا جاتا ہے",
  "Close menu": "مینو بند کریں",
  "Open menu": "مینو کھولیں",
  "Notes": "نوٹس",
  "Send message": "پیغام بھیجیں",
  "Languages": "زبانیں",
  "Consent status": "رضامندی کی حالت",
  "Select": "منتخب کریں",
  "Language selector": "زبان منتخب کریں",
  "Sorry": "معذر",
  "we couldn't find that page": "ہمیں وہ صفحہ نہیں مل سکا",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "آپ ابھی تک فیملی پورٹل میں لاگ ان کرنے کے مجاز نہیں ہیں۔ براہ کرم رسائی کے لیے اپنے دیکھ بھال کرنے والے بالغ سے رابطہ کریں۔"
}